module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn step-container plan-payment"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('step', {
    attrs: {
      "currentStep": 1,
      "maxStep": 3
    },
    on: {
      "step_clicked": _vm.gotoPage
    }
  }, [_c('div', {
    slot: "1"
  }, [_vm._v("กรอกรายละเอียด")]), _vm._v(" "), _c('div', {
    slot: "2"
  }, [_vm._v("การชำระเงิน")]), _vm._v(" "), _c('div', {
    slot: "3"
  }, [_vm._v("ยืนยัน")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('h4', {
    staticClass: "step-header"
  }, [_vm._v("รายละเอียดบริการ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.selectedPlan.name) + " ")]), _vm._v(" "), _c('br'), _vm._v(" \n                    " + _vm._s(_vm.selectedPlan.detail) + "\n                  ")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.selectedPlan.duration))]), _vm._v(" "), _c('td', [_vm._v("฿" + _vm._s(_vm._f("formatNumber")(_vm.selectedPlan.price)))])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("ค่าธรรมเนียม (3.8%)")]), _vm._v(" "), _c('td', [_vm._v("฿" + _vm._s(_vm._f("formatNumber")(_vm.creditCardFee)))])]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("รวมทั้งหมด")]), _vm._v(" "), _c('td', [_vm._v("฿" + _vm._s(_vm._f("formatNumber")(_vm.selectedPlan.price + _vm.creditCardFee)))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6 form-group text-left"
  }, [_c('router-link', {
    staticClass: "btn btn-link btn-lg",
    attrs: {
      "to": '/package'
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-circle-o-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('action_message.back')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 form-group text-right"
  }, [_c('router-link', {
    staticClass: "btn btn-store btn-lg",
    attrs: {
      "to": _vm.step2Link + _vm.addAppParams
    }
  }, [_vm._v("ต่อไป "), _c('i', {
    staticClass: "fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("สมัครแพลนการใช้งาน")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('h6')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Detail")]), _vm._v(" "), _c('th', [_vm._v("ระยะเวลา")]), _vm._v(" "), _c('th', [_vm._v("ราคา")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-661e5ea2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/package/payment/step1.vue
// module id = 1024
// module chunks = 1